import * as suppliers from './list'

export const allSuppliers = Object.values(suppliers).sort((previous, current) =>
    previous.name.localeCompare(current.name),
)
